import api from "./api";
import type { RoomPackage } from "../types";

const BASE_URL = "/admin/room-packages";

const roomPackageService = {
  getAll: () => api.get<RoomPackage[]>(BASE_URL),
  getActive: () => api.get<RoomPackage[]>(`${BASE_URL}/active`),
  getById: (id: string) => api.get<RoomPackage>(`${BASE_URL}/${id}`),
  create: (data: Partial<RoomPackage> & { inclusions?: any[] }) =>
    api.post<RoomPackage>(BASE_URL, data),
  update: (id: string, data: Partial<RoomPackage> & { inclusions?: any[] }) =>
    api.put<RoomPackage>(`${BASE_URL}/${id}`, data),
  delete: (id: string) => api.delete(`${BASE_URL}/${id}`),
};

export default roomPackageService;
